import { gql } from '@apollo/client';
import { Badge, Link } from '@apollo/orbit';
import React from 'react';
import { useLocation } from 'react-router';

import { insightsRouteConfig } from 'src/app/graph/routes';
import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import {
  TimestampTooltip,
  coerceToMoment,
} from 'src/components/timestamp/Timestamp';
import { Config } from 'src/lib/config/config';
import { ErrorTraceRefFragment } from 'src/lib/graphqlTypes/types';
import { RouteConfig } from 'src/lib/routeConfig/RouteConfig';

export const errorTraceRefFragment = gql`
  fragment ErrorTraceRefFragment on ErrorTraceRef {
    traceId
    operationId
    timestamp
  }
`;

export function TraceRefBadge({
  traceRef,
}: {
  traceRef: ErrorTraceRefFragment;
}) {
  const location = useLocation();
  const timestamp = coerceToMoment(traceRef.timestamp);
  return (
    <Link
      key={traceRef.traceId}
      to={insightsRouteConfig.locationFrom({
        location,
        patch: {
          [Config.queryParameters.ActiveReportPaneTab]: 'traces',
          [Config.queryParameters.SelectedTraceId]: traceRef.traceId,
          [Config.queryParameters.SelectedQueryId]: traceRef.operationId,
          errorsDrilldown: RouteConfig.DELETE,
          errorsServiceFilter: RouteConfig.DELETE,
          errorsCodeFilter: RouteConfig.DELETE,
          errorsPathFilter: RouteConfig.DELETE,
        },
        fromRouteConfig: insightsRouteConfig,
      })}
    >
      <Tooltip
        placement="top"
        interactive
        label={<TimestampTooltip date={timestamp} />}
      >
        <Badge
          variant="info"
          className="px-2 py-3.5 text-sm hover:bg-info-hover/30"
        >
          {timestamp.format('lll')}
        </Badge>
      </Tooltip>
    </Link>
  );
}
